import ProfilePicture from './ProfilePicture'

export default ProfilePicture
